import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Path } from "enums";
import RedeemPointsModule from "modules/vip-loyalty/redeem-points/redeem-points.module";

const VIPLoyaltyPage = () => {
  return (
    <Switch>
      <Route exact path={Path.VIPRedeemPoints} component={RedeemPointsModule} />
      <Redirect to={Path.VIPRedeemPoints} />
    </Switch>
  );
};

export default VIPLoyaltyPage;
